import React, { useEffect, useContext, useCallback, useImperativeHandle, useState } from 'react';
import { HelpDotIcon } from "../../../internal/icons/16px";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { isFunction } from "../../../lib/utils";
import { Tooltip } from "../../Tooltip";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Textarea.styles";

var handleHelpMouseDown = function handleHelpMouseDown(e) {
  return e.preventDefault();
};

export var TextareaCounter = /*#__PURE__*/React.forwardRef(function TextareaCounter(_ref, ref) {
  var _cx;

  var length = _ref.length,
      value = _ref.value,
      help = _ref.help,
      onCloseHelp = _ref.onCloseHelp,
      textarea = _ref.textarea;
  var theme = useContext(ThemeContext);

  var _useState = useState(textarea.clientWidth),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = useState(textarea.clientHeight),
      height = _useState2[0],
      setHeight = _useState2[1];

  var reflow = function reflow() {
    var clientWidth = textarea.clientWidth,
        clientHeight = textarea.clientHeight;
    setWidth(clientWidth);
    setHeight(clientHeight);
  };

  useEffect(reflow, [textarea]);
  useImperativeHandle(ref, function () {
    return {
      reflow: reflow
    };
  }, [ref]);
  var renderTooltipContent = useCallback(function () {
    return help;
  }, [help]);
  var textareaValue = value ? value.toString().length : 0;
  var counterValue = length - textareaValue;
  var counterHelp = isFunction(help) ? help() : /*#__PURE__*/React.createElement(Tooltip, {
    pos: 'right bottom',
    trigger: 'click',
    render: renderTooltipContent,
    onCloseClick: onCloseHelp
  }, /*#__PURE__*/React.createElement(HelpDotIcon, {
    onMouseDown: handleHelpMouseDown,
    color: theme.textareaCounterHelpIconColor
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.counterContainer(theme),
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: cx(styles.counter(theme), (_cx = {}, _cx[styles.counterError(theme)] = counterValue < 0, _cx))
  }, counterValue, help && /*#__PURE__*/React.createElement("span", {
    className: styles.counterHelp()
  }, counterHelp)));
});